<template>
  <div>
    <c-search-box @enter="getList">
      <template slot="search">
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <!-- 사업장 -->
          <c-plant type="search" name="plantCd" v-model="searchParam.plantCd" />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <c-vendor
            :editable="editable"
            :selfFlag="false"
            label="협력업체"
            name="vendorCd"
            v-model="searchParam.vendorCd"
          />
        </div>
      </template>
    </c-search-box>
    <c-table
      ref="grid"
      title="안전보건관리계획서 목록"
      :columns="grid.columns"
      :data="grid.data"
      @linkClick="linkClick"
    >
      <!-- 버튼 영역 -->
      <template slot="table-button">
        <q-btn-group outline >
          <c-btn label="안전보건관리계획서 샘플관리" v-if="editable" icon="add" @btnClicked="opeonSample" />
          <c-btn label="LBLSEARCH" icon="search" @btnClicked="getList" />
        </q-btn-group>
      </template>
    </c-table>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>

<script>
import selectConfig from '@/js/selectConfig';
export default {
  name: 'traning',
  data() {
    return {
      grid: {
        columns: [
          {
            name: 'plantName',
            field: 'plantName',
            label: 'LBLPLANT',
            align: 'center',
            sortable: true,
            style: 'width:120px',
          },
          {
            name: 'vendorName',
            field: 'vendorName',
            label: '도급업체',
            align: 'center',
            sortable: true,
            style: 'width:300px',
          },
          {
            name: 'constructionName',
            field: 'constructionName',
            label: '공사명',
            align: 'left',
            sortable: true,
            type: 'link',
          },
          {
            name: 'startDt',
            field: 'startDt',
            label: '공사시작일',
            align: 'center',
            style: 'width:150px',
            sortable: true,
          },
          {
            name: 'endDt',
            field: 'endDt',
            label: '공사종료일',
            align: 'center',
            style: 'width:150px',
            sortable: true,
          },
          {
            name: 'manageUserName',
            field: 'manageUserName',
            label: '현업담당자',
            align: 'center',
            style: 'width:150px',
            sortable: true,
          },
          {
            name: 'vendorSafetyPlanStepName',
            field: 'vendorSafetyPlanStepName',
            label: '승인상태',
            align: 'center',
            style: 'width:150px',
            sortable: true,
          },
        ],
        data: [],
      },
      searchParam: {
        plantCd: null,
        vendorCd: null,
      },
      searchUrl: '',
      editable: true,
      popupOptions: {
        isFull: true,
        target: null,
        title: '',
        visible: false,
        top: '',
        param: {},
        closeCallback: null,
      },
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      this.editable = this.$route.meta.editable;
      this.listUrl = selectConfig.sai.vendor.safety.plan.list.url;
      this.getList();
    },
    getList() {
      this.$http.url = this.listUrl;
      this.$http.type = 'GET';
      this.$http.param = this.searchParam;
      this.$http.request((_result) => {
        this.grid.data = _result.data;
      },);
    },
    linkClick(row) {
      this.popupOptions.title = '안전보건관리계획서 상세'; // 안전보건관리계획서 상세
      this.popupOptions.param = {
        vendorSafetyPlanId: row ? row.vendorSafetyPlanId : '',
      };
      this.popupOptions.target = () => import(`${'./safetyPlanDetail.vue'}`);
      this.popupOptions.visible = true;
      this.popupOptions.isFull = false;
      this.popupOptions.width = '90%';
      this.popupOptions.closeCallback = this.closePopup;
    },
    closePopup() {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      this.getList();
    },
    opeonSample() {
      this.popupOptions.title = '안전보건관리계획서 샘플관리'; // 안전보건관리계획서 샘플관리
      this.popupOptions.target = () => import(`${'./safetyPlanPop.vue'}`);
      this.popupOptions.visible = true;
      this.popupOptions.isFull = false;
      this.popupOptions.width = '40%';
      this.popupOptions.closeCallback = this.closePopupSample;
    },
    closePopupSample() {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
    },
  }
};
</script>
